<template>
    <div style="height: 100%;" class="mydatadiv">
        <van-tabs type="card" @change="dateChange" v-model="active" style="padding: 5px;">
            <van-tab title="今天"></van-tab>
            <van-tab title="昨天"></van-tab>
            <van-tab title="本月"></van-tab>
            <van-tab title="上月"></van-tab>
        </van-tabs>
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="品牌">
                <el-select v-model="selectparentid" style="width: 100px" size="mini" placeholder="选择品牌" clearable @change="parentChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.parentname" :value="item.parentid" :key="key" v-for="(item,key) in parentInfos"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="门店">
                <el-select v-model="selectstoreid" style="width: 100px" size="mini" placeholder="" @change="storeChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option :label="item.storename" :value="item.storeid" :key="key" v-for="(item,key) in inteboStores"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="checked" @change="getInteboStaffData">自己</el-checkbox>
            </el-form-item>
        </el-form>
        <el-form class="demo-form-inline">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="总现金:">{{totalbean.totalcashamount}}</el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="总购买次数:">{{totalbean.totalcashnumber}}</el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="总消耗金额:">{{totalbean.totalxhamount}}</el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="总消耗次数:">{{totalbean.totalxhnumber}}</el-form-item>
                </el-col>
            </el-row>
        </el-form>
        
        <el-table height="calc(100% - 11rem)"  border :data="myData" size="mini" style="text-align: center" highlight-current-row class="tableBox">
            <el-table-column label="门店" align="center" prop="storename" width="100">
                <template slot-scope="scope">
                    <div >{{scope.row.storename}}</div>
                    <div >{{scope.row.accountdate}}</div>
                </template>
            </el-table-column>
            <el-table-column label="客人" align="center" prop="hzstorename" width="100">
                <template slot-scope="scope">
                    <div >{{scope.row.cardnumber}}-{{scope.row.membername}}</div>
                </template>
            </el-table-column>
            <el-table-column label="项目" align="center" prop="hzstorename">
                <template slot-scope="scope">
                    <div >{{scope.row.projectname}}</div>
                    <div >
                        <span v-if="scope.row.type==1">(购买)</span><span v-if="scope.row.type==2">(消耗)</span>{{scope.row.number}}次({{scope.row.realamount}})-{{scope.row.staffname1}}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                inteboStores:[],
                checked:false,
                selectparentid:"",
                selectstoreid:"",
                active:0,
                myData:[],
                totalbean:{
                    totalcashamount:0,
                    totalcashnumber:0,
                    totalxhamount:0,
                    totalxhnumber:0,
                },
                storeid:localStorage.getItem("storeid"),
                staffid:localStorage.getItem("staffid"),
                fromdate:this.$moment().format("YYYY-MM-DD"),
                todate:this.$moment().format("YYYY-MM-DD"),
                parentInfos:[],
            }
        },
        created() {
            this.getInteboStaffData();
            this.getInteboParentStore();
        },
        methods:{
            storeChange(){
                this.getInteboStaffData();
            },
            parentChange(v){
                this.getInteboStore();
                this.getInteboStaffData();
            },
            getInteboStore(){
                this.$post("inteboStore/getInteboStoreByCoopByStaff",{parentid:this.selectparentid,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.inteboStores=res.object;
                    }
                });
            },
            getInteboParentStore(){
                this.$post("inteboStore/getInteboParentStoreByCoopByStaff",{staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.parentInfos=res.object;
                    }
                });
            },
            dateChange(e){
                console.log(e);
                if(this.active==0){
                    this.fromdate=this.$moment().format("YYYY-MM-DD");
                    this.todate=this.$moment().format("YYYY-MM-DD");
                }
                else if(this.active==1){
                    this.fromdate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.todate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                }
                else if(this.active==2){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(this.active==3){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.fromdate=days+"-01";
                    this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                }
                this.getInteboStaffData();
            },
            getInteboStaffData(){
                let type=0;
                if(this.checked){
                    type=1;
                }
                this.$post("inteboStaff/getInteboStaffData",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate,staffid:this.staffid,parentid:this.selectparentid,
                selectstoreid:this.selectstoreid,type:type}).then(res=>{
                    if(res.sucess){
                        this.myData=res.object;
                        this.totalbean.totalcashamount=0;
                        this.totalbean.totalcashnumber=0;
                        this.totalbean.totalxhamount=0;
                        this.totalbean.totalxhnumber=0;
                        if(this.myData!=null && this.myData.length>0){
                            for(let val of this.myData){
                                if(val.type==1){
                                    this.totalbean.totalcashamount=this.$parseInt(this.totalbean.totalcashamount)+this.$parseInt(val.realamount);
                                    this.totalbean.totalcashnumber=this.$parseInt(this.totalbean.totalcashnumber)+this.$parseInt(val.number);
                                }
                                if(val.type==2){
                                    this.totalbean.totalxhamount=this.$parseInt(this.totalbean.totalxhamount)+this.$parseInt(val.realamount);
                                    this.totalbean.totalxhnumber=this.$parseInt(this.totalbean.totalxhnumber)+this.$parseInt(val.number);
                                }
                            }
                        }
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
   .demo-form-inline .el-form-item{
        margin-bottom:0px;
    }


    .mydatadiv .el-table--mini td, .el-table--mini th{
        padding:0px;
    }
   
</style>



// WEBPACK FOOTER //
// src/page/intebo/mydata.vue